export const grassTypeTips = {
  cool: {
    text: "Where you live, cool-season grass grows best. Let's find out what else you're looking for and get you the right amount for your ",
    imageUrl: '/icons/seed-finder/cool-map.svg',
    alt: 'A map of the US highlighting the northern, cool-season grass region',
  },
  warm: {
    text: "Where you live, warm-season grass grows best. Let's find out what else you're looking for and get you the right amount for your ",
    imageUrl: '/icons/seed-finder/warm-map.svg',
    alt: 'A map of the US highlighting the southern, warm-season grass region',
  },
};

export const purposeToProblemMap = {
  'over-seeding': {
    icon: '/icons/seed-finder/overseeding.svg',
    text: (
      <span>
        Thinning <br />
        grass
      </span>
    ),
    displayText: 'thinning grass',
    alt: 'grass',
  },
  patching: {
    icon: '/icons/seed-finder/patching.svg',
    text: 'Bare patches',
    displayText: 'bare patches',
    alt: 'grass bare spots being seeded',
  },
  seeding: {
    icon: '/icons/seed-finder/overseeding.svg',
    text: (
      <span>
        Starting a <br />
        new lawn
      </span>
    ),
    displayText: 'starting a new lawn',
    alt: 'grass',
  },
};

export const grassSpeciesMap = {
  bermudagrass: {
    icon: '/icons/seed-finder/overseeding.svg',
    text: 'Bermuda',
    alt: 'grass',
  },
  other: {
    icon: '/icons/seed-finder/unknown-grass.svg',
    text: 'Unknown grass',
    alt: 'grass with question mark',
  },
  'st-augustinegrass': {
    icon: '/icons/seed-finder/st-augustine-grass.svg',
    text: 'St. Augustine',
    alt: 'grass',
  },
};

export const grassSeasonMap = {
  'seed-warm': {
    icon: '/icons/seed-finder/southern-staple.svg',
    text: 'Warm season',
    alt: 'sun',
  },
  'seed-cool': {
    icon: '/icons/seed-finder/cold-tolerant.svg',
    text: 'Cool season',
    alt: 'snowflake',
  },
};

export const ProductContent = {
  BSS1003: {
    displayName: (
      <span>
        Bare Repair <br />
        Bermudagrass
      </span>
    ),
    lawnFeature: {
      text: 'Warm season',
      icon: '/icons/seed-finder/southern-staple.svg',
      alt: 'sun',
    },
    features: [
      {
        text: 'Easy to use',
        icon: '/icons/seed-finder/easy.svg',
        alt: 'hand snapping',
      },
      {
        text: (
          <span>
            Perfect for <br />
            patching
          </span>
        ),
        icon: '/icons/seed-finder/patching.svg',
        alt: 'grass bare spot being seeded',
      },
      {
        text: (
          <span>
            Combo <br />
            formula
          </span>
        ),
        icon: '/icons/seed-finder/combo-formula.svg',
        alt: 'science beaker',
      },
    ],
    description:
      'Bare Repair blends fertilizer, mulch, and grass seed so you can quickly and easily repair lawn patches with just a shake.',
  },
  BSS1004: {
    displayName: (
      <span>
        Bermuda Time <br />
        Grass Seed
      </span>
    ),
    lawnFeature: {
      text: 'Warm season',
      icon: '/icons/seed-finder/southern-staple.svg',
      alt: 'sun',
    },
    features: [
      {
        text: (
          <span>
            Southern <br />
            staple
          </span>
        ),
        icon: '/icons/seed-finder/southern-staple.svg',
        alt: 'sun',
      },
      {
        text: (
          <span>
            Heat <br />
            tolerant
          </span>
        ),
        icon: '/icons/seed-finder/heat-tolerant.svg',
        alt: 'thermometer',
      },
      {
        text: (
          <span>
            Drought <br />
            resistant
          </span>
        ),
        icon: '/icons/seed-finder/drought.svg',
        alt: 'dry soil',
      },
    ],
    description:
      'Bermuda Time is great for sunny southern lawns, with excellent heat and drought tolerance and a 99.9% weed-free guarantee.',
  },
  BPS1003: {
    displayName: (
      <span>
        Pet Lawn <br />
        Bare Repair
      </span>
    ),
    lawnFeature: {
      text: 'Pet friendly',
      icon: '/icons/seed-finder/paw.svg',
      alt: 'paw print',
    },
    features: [
      {
        text: (
          <span>
            Perfect for <br />
            patching
          </span>
        ),
        icon: '/icons/seed-finder/patching.svg',
        alt: 'grass bare spot being seeded',
      },
      {
        text: 'Easy to use',
        icon: '/icons/seed-finder/easy.svg',
        alt: 'hand snapping',
      },
      {
        text: (
          <span>
            Combo <br />
            formula
          </span>
        ),
        icon: '/icons/seed-finder/combo-formula.svg',
        alt: 'science beaker',
      },
    ],
    description:
      'Pet Lawn Bare Repair mixes urine-resistant grass seed with mulch and slow-release nitrogen—a pet-friendly fix for patches.',
  },
  BPS1002: {
    displayName: (
      <span>
        Pet Lawn <br />
        Grass Seed
      </span>
    ),
    lawnFeature: {
      text: 'Pet friendly',
      icon: '/icons/seed-finder/paw.svg',
      alt: 'paw print',
    },
    features: [
      {
        text: (
          <span>
            Pet <br />
            friendly
          </span>
        ),
        icon: '/icons/seed-finder/paw.svg',
        alt: 'paw print',
      },
      {
        text: (
          <span>
            Urine <br />
            resistant
          </span>
        ),
        icon: '/icons/seed-finder/pet-urine.svg',
        alt: 'crossed-out paw print',
      },
      {
        text: (
          <span>
            Proven <br />
            resilient
          </span>
        ),
        icon: '/icons/seed-finder/resilient.svg',
        alt: 'strong arm',
      },
    ],
    description:
      'Pet Lawn is packed with a perennial ryegrass and fescue seed mixture that resists damage from urine and withstands paw traffic!',
  },
  BSS1002: {
    displayName: (
      <span>
        Bare Repair <br />
        Sun + Shade
      </span>
    ),
    lawnFeature: {
      text: 'Cool season',
      icon: '/icons/seed-finder/cold-tolerant.svg',
      alt: 'snowflake',
    },
    features: [
      {
        text: (
          <span>
            Perfect for <br />
            patching
          </span>
        ),
        icon: '/icons/seed-finder/patching.svg',
        alt: 'grass bare spot being seeded',
      },
      {
        text: 'Easy to use',
        icon: '/icons/seed-finder/easy.svg',
        alt: 'hand snapping',
      },
      {
        text: (
          <span>
            Combo <br />
            formula
          </span>
        ),
        icon: '/icons/seed-finder/combo-formula.svg',
        alt: 'science beaker',
      },
    ],
    description:
      'Bare Repair blends fertilizer, mulch, and grass seed so you can quickly and easily repair lawn patches with just a shake.',
  },
  SSA5505: {
    displayName: (
      <span>
        Lucky Lawn <br />
        Grass Seed
      </span>
    ),
    lawnFeature: {
      text: 'Pollinator friendly',
      icon: '/icons/seed-finder/pollinator.svg',
      alt: 'bee',
    },
    features: [
      {
        text: (
          <span>
            Pollinator <br />
            friendly
          </span>
        ),
        icon: '/icons/seed-finder/pollinator.svg',
        alt: 'bee',
      },
      {
        text: 'Easy care',
        icon: '/icons/seed-finder/easy.svg',
        alt: 'hand snapping',
      },
      {
        text: (
          <span>
            Grows where <br />
            grass struggles
          </span>
        ),
        icon: '/icons/seed-finder/resilient.svg',
        alt: 'strong arm',
      },
    ],
    description:
      'Lucky Lawn mixes clover and fescue seeds for a pollinator-friendly lawn that crowds out weeds and grows where other grass struggles!',
  },
  SSA5503: {
    displayName: (
      <span>
        Shade Select <br />
        Grass Seed
      </span>
    ),
    lawnFeature: {
      text: 'Lots of shade',
      icon: '/icons/seed-finder/shade.svg',
      alt: 'umbrella',
    },
    features: [
      {
        text: (
          <span>
            Thrives <br />
            in shade
          </span>
        ),
        icon: '/icons/seed-finder/shade.svg',
        alt: 'umbrella',
      },
      {
        text: (
          <span>
            Low water <br />
            needs
          </span>
        ),
        icon: '/icons/seed-finder/water.svg',
        alt: 'water droplet',
      },
      {
        text: (
          <span>
            Reduced <br />
            mowing
          </span>
        ),
        icon: '/icons/seed-finder/mow.svg',
        alt: 'lawn mower',
      },
    ],
    description:
      'Shade Select is low-maintenance seed mixture, requiring less fertilizer and mowing than others. Plus it tolerates—you guessed it!—shade.',
  },
  BSS1001: {
    displayName: (
      <span>
        Fescue Rescue <br />
        Grass Seed
      </span>
    ),
    lawnFeature: {
      text: 'Cool with some sun',
      icon: '/icons/seed-finder/cool-sun.svg',
      alt: 'Sun with partial clouds',
    },
    features: [
      {
        text: 'Easy care',
        icon: '/icons/seed-finder/easy.svg',
        alt: 'hand snapping',
      },
      {
        text: (
          <span>
            Drought <br />
            resistant
          </span>
        ),
        icon: '/icons/seed-finder/drought.svg',
        alt: 'dry soil',
      },
      {
        text: (
          <span>
            Traffic <br />
            tolerant
          </span>
        ),
        icon: '/icons/seed-finder/foot-traffic.svg',
        alt: 'footprints',
      },
    ],
    description:
      'Fescue Rescue tolerates heat, drought, and partial shade. Because this seed isn’t demanding in terms of sun and nutrients, it’s easy to care for.',
  },
  SSA5502: {
    displayName: (
      <span>
        Kentucky's Best <br />
        Grass Seed
      </span>
    ),
    features: [
      {
        text: (
          <span>
            Famously <br />
            soft
          </span>
        ),
        icon: '/icons/seed-finder/soft.svg',
        alt: 'bent leaf',
      },
      {
        text: (
          <span>
            Cold <br />
            tolerant
          </span>
        ),
        icon: '/icons/seed-finder/cold-tolerant.svg',
        alt: 'snowflake',
      },
      {
        text: (
          <span>
            Higher <br />
            water needs
          </span>
        ),
        icon: '/icons/seed-finder/water.svg',
        alt: 'water droplet',
      },
    ],
    description:
      'Kentucky’s Best grows grass that’s soft on bare feet, has excellent cold tolerance, and boasts dense emerald turf that resists weeds.',
  },
};

export const didYouKnowContent = {
  'seeding-timing-cool': {
    title: 'Did you know?',
    content:
      "Fall is prime time for seeding! The temps are right for germination, weeds are less competitive, and you'll replace any grass that died off from summer stress.",
    alternateDesign: true,
    iconName: 'lightbulb.png',
  },
  'seeding-timing-warm': {
    title: 'Did you know?',
    content:
      'Fall is your last chance to patch any bare spots before winter! 70–90℉ is the sweet spot for patching where you live.',
    alternateDesign: true,
    iconName: 'lightbulb.png',
  },
  'seeding-area': {
    title: 'Sunday tip',
    content:
      "Pre-emergents (aka “weed & feed”) prevent seed germination! If you've recently applied one, wait to seed.",
    iconName: 'sun-white.svg',
  },
  seeding: {
    title: 'New lawn seeding rate',
    content:
      'When growing a new lawn from scratch, we recommend applying about 5 pounds of seed (one bag) per 1,250 square feet.',
    iconName: 'seeding-rate.svg',
  },

  patching: {
    title: 'Patching rate',
    content:
      'Have more or less patchiness than our 1% estimate? You can adjust your seed quantity on the next page.',
    iconName: 'seeding-rate.svg',
  },

  'over-seeding': {
    title: 'Overseeding rate',
    content:
      'For thinning grass, we recommend buying enough seed to cover your entire yard one time. We find that more seed works better than less.',
    iconName: 'seeding-rate.svg',
  },
  'has-pets': {
    title: 'Did you know?',
    content:
      'All Sunday products are fur-friendly when used as directed. But some are designed to better tolerate the ruff and tumble activities of our pets.',
    iconName: 'lightbulb.png',
    alternateDesign: true,
  },
  'wants-clover': {
    title: 'Did you know?',
    content:
      'Clover was commonly grown with grass to boost lawn resilience until the 1950s, when herbicide companies began demonizing it to increase sales.',
    iconName: 'lightbulb.png',
    alternateDesign: true,
  },
  'has-shade': {
    title: 'Sunday tip',
    content:
      'Grow resilient turf by mowing high to encourage deeper root growth—especially for shaded grass which is more vulnerable to foot traffic and heat stress.',
    iconName: 'sun-white.svg',
  },

  'grass-species': {
    title: 'Did you know?',
    content:
      'Warm-season lawns usually consist of just one grass type—and the folks who grow them tend to be loyal. Cool-season grasses, conversely, are often blended.',
    iconName: 'lightbulb.png',
    alternateDesign: true,
  },
};
